import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-poll-alert-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './poll-alert-overlay.component.html',
  styleUrls: ['./poll-alert-overlay.component.scss'],
})
export class PollAlertOverlayComponent {
  @Input() level = 1;

  private readonly messagesByLevel: Record<number, { title: string; description: string }> = {
    1: {
      title: 'Tem mensagem demais chegando de uma vez só.',
      description: 'O limite configurado para respostas rápidas consecutivas foi atingido.',
    },
    2: {
      title: 'Tem mais atividade do que o normal por aqui',
      description:
        'O volume de respostas ultrapassou o limite definido em relação a média histórica.',
    },
  };

  private readonly defaultMessage = {
    title: 'Atividade incomum detectada neste dispositivo.',
    description: 'Aguarde alguns instantes antes de continuar com novas respostas.',
  };

  private get message() {
    return this.messagesByLevel[this.level] ?? this.defaultMessage;
  }

  get title(): string {
    return this.message.title;
  }

  get description(): string {
    return this.message.description;
  }
}
